import queryString from "query-string";
import { OFFER_TYPES } from "../constants/offerTypes";

const offerType = (clientConfig, historySearch = null) => {
  if (historySearch) {
    const urlParams = queryString.parse(historySearch);
    const offerTypeKey = `tds-pc-${clientConfig.id}[offerType]`;
    const type = urlParams[offerTypeKey];

    if (OFFER_TYPES[type]) {
      return type;
    }
  }

  if (
    clientConfig.widgetOptions.proposition.show &&
    clientConfig.widgetOptions.proposition.initialShow
  ) {
    return "proposition";
  } else if (
    clientConfig.widgetOptions.simOnly.show &&
    clientConfig.widgetOptions.simOnly.initialShow
  ) {
    return "simOnly";
  } else if (
    clientConfig.widgetOptions.phoneOffer.show &&
    clientConfig.widgetOptions.phoneOffer.initialShow
  ) {
    return "phoneOffer";
  } else if (clientConfig.widgetOptions.proposition.show) {
    return "proposition";
  } else if (clientConfig.widgetOptions.simOnly.show) {
    return "simOnly";
  } else if (clientConfig.widgetOptions.phoneOffer.show) {
    return "phoneOffer";
  }
};

const offerTypeFromWidgetName = widgetName => {
  return widgetName.split("_")[2];
};

const offerTypeToOffersName = offerType => {
  if (offerType === OFFER_TYPES.phoneOffer) {
    return "phoneOffers";
  } else if (offerType === OFFER_TYPES.proposition) {
    return "propositions";
  } else if (offerType === OFFER_TYPES.simOnly) {
    return "simOnlyOffers";
  }
};

export { offerType, offerTypeFromWidgetName, offerTypeToOffersName };
